import PropTypes from 'prop-types';

export const linkPropType = PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
})

export const PHOTO_PROP_TYPE = PropTypes.shape({
    id: PropTypes.string,
    url: PropTypes.string
});

export const AUCTION_PROP_TYPE = PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    userId: PropTypes.string,
    description: PropTypes.string,
    auctioneerName: PropTypes.string,
    auctioneerCity: PropTypes.string,
    auctioneerState: PropTypes.string,
    companyWebsite: PropTypes.string,
    date: PropTypes.string,
    beginTime: PropTypes.string,
    endDate: PropTypes.string,
    endTime: PropTypes.string,
    photos: PropTypes.arrayOf(PHOTO_PROP_TYPE),
    biddingUrl: PropTypes.string,
    terms: PropTypes.string,
    directions: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    street: PropTypes.string,
    videoUrl: PropTypes.string,
    zip: PropTypes.string,
});

export const AUCTIONEER_PROP_TYPE = PropTypes.shape({
    webAddress: PropTypes.string,
    title: PropTypes.string,
    company: PropTypes.string,
    phone: PropTypes.string,
    address: PropTypes.string,
    email: PropTypes.string,
    photoUrl: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
});

export const CATEGORY_PROP_TYPE = PropTypes.shape({
    display: PropTypes.string,
    value: PropTypes.string,
});

export const REACT_SELECT_OPTIONS_PROP_TYPE = PropTypes.arrayOf(
    PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired
    })
);
